import { render, staticRenderFns } from "./storeList.vue?vue&type=template&id=ff4de772&scoped=true"
import script from "./storeList.vue?vue&type=script&lang=js"
export * from "./storeList.vue?vue&type=script&lang=js"
import style0 from "./storeList.vue?vue&type=style&index=0&id=ff4de772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4de772",
  null
  
)

export default component.exports